/** @format */

import { notificationConstants } from '../notifications/notifications';
import { reducerDebug } from '../../core/debug';

export type discountReducersType = {
    type?: string;
    collections?: any;
    item?: any;
    processSuccess?: boolean;
    success?: boolean;
    data?: any;
    deletedSuccess?: boolean;
    message?: string;
};

export const DISCOUNT_CONSTANTS = {
    LIST: 'discount_list',
    ITEM: 'discount_item',
    EDIT: 'discount_edit',
    DELETE: 'discount_delete',
    MANAGE: 'discount_manage',
    ADD: 'discount_add',
};

export function discountReducers(state = {}, action: discountReducersType): object {
    reducerDebug('Discount reducer: ' + action.type);
    switch (action.type) {
        case DISCOUNT_CONSTANTS.LIST:
            return {
                ...state,
                type: action.type,
                collections: action.collections,
            };
        case DISCOUNT_CONSTANTS.ITEM:
            return {
                ...state,
                type: action.type,
                item: action.item,
            };
        case DISCOUNT_CONSTANTS.ADD:
        case DISCOUNT_CONSTANTS.EDIT:
            return {
                ...state,
                type: action.type,
                success: true,
                data: action.data,
            };
        case DISCOUNT_CONSTANTS.DELETE:
            return {
                ...state,
                type: action.type,
                deletedSuccess: true,
            };
        case notificationConstants.ERROR:
            return {
                type: action.type,
                message: action.message,
            };
        default:
            return {
                ...state,
            };
    }
}
